const t = (key, label) => ({ key, label, type: "text" });
const ta = (key, label) => ({ key, label, type: "textarea" });
const img = (key, label) => ({ key, label, type: "image" });
const list = (key, label, fields) => ({ key, label, type: "list", fields });

export const SECTIONS = [
  { id: "general", title: "GENERALE & MENU", fields: [
    t("brand_part1", "Logo — parte bianca"), t("brand_part2", "Logo — parte verde"),
    t("nav_events", "Menu: Eventi"), t("nav_tables", "Menu: Tavoli"), t("nav_carpool", "Menu: Carpool"),
    t("nav_affiliation", "Menu: Affiliazione"), t("nav_gallery", "Menu: Gallery"), t("nav_contacts", "Menu: Contatti"),
  ]},
  { id: "home", title: "HOME", fields: [
    img("home_hero_image", "Immagine di sfondo principale"),
    t("home_badge", "Scritta piccola sopra il titolo"),
    t("home_title_line1", "Titolo riga 1 (le / diventano verdi)"), t("home_title_accent", "Titolo riga 2 — parola rossa"),
    t("home_title_line2", "Titolo riga 2 — resto"), ta("home_subtitle", "Sottotitolo"),
    t("home_subtitle_highlight", "Sottotitolo — frase verde finale"), t("home_marquee", "Testo che scorre"),
    t("home_events_label", "Etichetta sezione eventi"), t("home_events_title", "Titolo sezione eventi"),
    t("home_list_button", "Pulsante lista sugli eventi"),
  ]},
  { id: "tables", title: "TAVOLI", fields: [
    t("tables_label", "Etichetta"), ta("tables_title", "Titolo (vai a capo per 2 righe)"),
    ta("tables_subtitle", "Sottotitolo"), t("tables_subtitle_highlight", "Frase rossa finale"),
  ]},
  { id: "carpool", title: "CARPOOLING", fields: [
    t("carpool_label", "Etichetta"), ta("carpool_title", "Titolo (le / diventano rosse)"), ta("carpool_subtitle", "Sottotitolo"),
  ]},
  { id: "aff", title: "AFFILIAZIONE", fields: [
    t("aff_label", "Etichetta"), ta("aff_title", "Titolo"), ta("aff_guest_text", "Testo per chi non è registrato"),
    list("tiers", "Livelli affiliati", [
      { name: "name", label: "Nome livello" }, { name: "min", label: "Crediti minimi" }, { name: "perks", label: "Vantaggi", wide: true },
    ]),
  ]},
  { id: "gallery", title: "GALLERY", fields: [
    t("gallery_label", "Etichetta"), t("gallery_title", "Titolo"), ta("gallery_subtitle", "Sottotitolo"),
    t("gallery_archive_label", "Etichetta archivio"), t("gallery_archive_title", "Titolo archivio"),
  ]},
  { id: "contacts", title: "CONTATTI & FAQ", fields: [
    t("faq_label", "Etichetta FAQ"), t("faq_title", "Titolo FAQ"),
    list("faqs", "Domande frequenti", [{ name: "q", label: "Domanda" }, { name: "a", label: "Risposta", wide: true }]),
    t("contact_label", "Etichetta contatti"), t("contact_title", "Titolo contatti"), ta("contact_text", "Testo contatti"),
    t("whatsapp_number", "WhatsApp — numero con prefisso, solo cifre (es. 393515685905)"),
    t("whatsapp_display", "WhatsApp — come appare"), t("instagram_handle", "Instagram — nome utente senza @"),
  ]},
  { id: "footer", title: "FOOTER", fields: [
    ta("footer_tagline", "Frase sotto il logo"), t("footer_copyright", "Copyright"), t("footer_made_in", "Made with █ …"),
  ]},
  { id: "scouting", title: "SOCIAL SCOUTING", fields: [
    list("scouting_links", "Link di ricerca", [
      { name: "platform", label: "Social" }, { name: "label", label: "Nome" }, { name: "url", label: "Link https://", wide: true },
    ]),
  ]},
  { id: "archive", title: "GALLERIA ARCHIVIO", fields: [] },
];
